var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["message-cloud", { answer: _vm.answer }] },
    [
      !_vm.answer
        ? [
            _c("div", { staticClass: "message-cloud__body-item" }, [
              _c("span", { staticClass: "message-cloud__body-key" }, [
                _vm._v("\n        Размер:\n      ")
              ]),
              _c("span", { staticClass: "message-cloud__body-value" }, [
                _vm._v("\n        " + _vm._s(_vm.size) + "\n      ")
              ])
            ]),
            _c("div", { staticClass: "message-cloud__body-item" }, [
              _c("span", { staticClass: "message-cloud__body-key" }, [
                _vm._v("\n        Достоинства:\n      ")
              ]),
              _c("span", { staticClass: "message-cloud__body-value" }, [
                _vm._v("\n        " + _vm._s(_vm.pros) + "\n      ")
              ])
            ]),
            _c("div", [
              _c("span", { staticClass: "message-cloud__body-key" }, [
                _vm._v("\n        Недостатки:\n      ")
              ]),
              _c("span", { staticClass: "message-cloud__body-value" }, [
                _vm._v("\n        " + _vm._s(_vm.cons) + "\n      ")
              ])
            ])
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "message-cloud__text message-cloud__body-value" },
        [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
      ),
      _vm.$slots.default
        ? _c(
            "div",
            { staticClass: "message-cloud__answers" },
            [_vm._t("default")],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }